/* eslint-disable @typescript-eslint/no-explicit-any */
// cihan
import React from "react";

import { CircularProgress, Dialog, DialogContent, Stack, Typography } from "@mui/material";

import { useAppSelector } from "../../app/hooks";
import { getLoadingMessage } from "../../features/loadingMessageSlice";
import Columns from "../../library/components/layout/Columns";
import CircularProgressWithLabel from "../../library/components/mui/helpers/CircularProgressWithLabel";
import Cell from "../../library/components/layout/Cell";

export function LoadingPanelProvider(props: any) {
    const loadingMessage = useAppSelector(getLoadingMessage).distinct();

    return (
        <React.Fragment>
            {React.Children.only(props.children)}
            <Dialog open={loadingMessage.length > 0}>
                <DialogContent>
                    <Stack alignItems={"center"}>
                        <CircularProgress />
                        {loadingMessage.map((item) => (
                            <Columns key={item.message}>
                                <Typography key={item.message}>{item.message}</Typography>
                                <Cell ml={15}>
                                    <CircularProgressWithLabel value={item.percent * 100} />
                                </Cell>
                            </Columns>
                        ))}
                    </Stack>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}